import { useState } from 'react';
import { AdminListPageWrapper } from '../../../AdminListPage';
import { ProUserSearchForm, ProUserFilters } from './ProUserSearchForm';
import { ProUserResultsTable } from './ProUserResultsTable';
import { AdminSearch } from '@platform/client';
import { DownloadResultsModal } from '../DownloadResultsModal';
import { proFiltersToQueryParams } from '../utils';

export const ProUserSearchPage = () => {
  const [filters, setFilters] = useState<ProUserFilters>();
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);

  return (
    <>
      {!filters && <ProUserSearchForm setFilters={setFilters} />}
      {filters && (
        <AdminListPageWrapper>
          <ProUserResultsTable
            filters={filters}
            setFilters={setFilters}
            setDownloadModalOpen={setDownloadModalOpen}
          />
        </AdminListPageWrapper>
      )}
      {downloadModalOpen && filters && (
        <ProUserDownloadModal filters={filters} onClose={() => setDownloadModalOpen(false)} />
      )}
    </>
  );
};

export const ProUserDownloadModal = ({
  filters,
  onClose,
}: {
  filters: ProUserFilters;
  onClose: () => void;
}) => {
  const { data, isLoading, isError, isSuccess } = AdminSearch.useGetProResultExportData(
    proFiltersToQueryParams(filters),
  );

  return (
    <DownloadResultsModal
      onClose={onClose}
      rows={data?.users ?? []}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      filenamePrefix='pro_export'
    />
  );
};
